import { useContext } from 'react';
import { CurrentLangContext, LangContext } from '../../contexts/contexts';
import './About.scss';

function About() {
  const langs = useContext(LangContext);
  const aboutLangs = langs.about;

  const CurrentLangC = useContext(CurrentLangContext);
  const currentLang = CurrentLangC[0];

  return (
    <section id="about" className="About">
      <h1 className="About_title">{aboutLangs[currentLang].title}</h1>
      <div className="About_content">
        <p>{aboutLangs[currentLang].subtitle}</p>
        <p>{aboutLangs[currentLang].content}</p>
        <p>{aboutLangs[currentLang].contact}</p>
      </div>
    </section>
  );
}

export default About;